module.exports = __webpack_public_path__ + "media/images/svg-icon/form_elements-415cc093e48f79b5231a719e51b8e083.svg";